// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__377__","label":"LabeledBox_label__3AoTE"};